const GAME_TYPE_TH: Record<string, string> = {
	SLOT: 'สล็อต',
	CASINO: 'คาสิโน',
	LOTTO: 'หวย',
	SPORT: 'กีฬา',
	FISHING: 'ยิงปลา',
}

export function formatGameTypeToThai(gameType: string): string {
	return GAME_TYPE_TH[gameType] ?? gameType
}

const CALCULATE_INTERVAL_TH: Record<string, string> = {
	DAILY: 'รายวัน',
	WEEKLY: 'รายสัปดาห์',
	MONTHLY: 'รายเดือน',
}

export function formatCalculateIntervalToThai(interval: string): string {
	return CALCULATE_INTERVAL_TH[interval] ?? interval
}

/** Credit amounts with 2 decimal places (Thai locale). */
export function formatCreditsAmount(value: number): string {
	return value.toLocaleString('th-TH', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})
}
